//Imports node_modules
import React from "react"
import ButtonAdvanced from "../../buttonAdvanced/ButtonAdvanced";

//Imports Css
import './BackButton.css'

//Imports Components

//Retorna um butão que volta para a página anterior
const BackButton = (params) => {

    //--- Variaveis

    //Variaveis locais
    let classes = 'preBtn '
    classes += params.voltar ? 'voltar ' : '';
    classes += params.cancelar ? 'cancelar ' : '';
    classes += params.continuar ? 'continuar ' : '';
    classes += params.voltar && params.isDisabled ? 'voltarDisabled ' : '';
    classes += params.cancelar && params.isDisabled ? 'cancelarDisabled ' : '';

    //--- Fim variaveis 

    return (
        <ButtonAdvanced
            className={classes}
            onClick={params.click}
            disabled={params.isDisabled ? params.isDisabled : false}
            text={params.backText ? params.backText : "Voltar"}>
        </ButtonAdvanced>
    )
}

export default BackButton

